<template>
  <div class="tw-relative">
    <cl-data-table
      :search-text="$t('search')"
      :selected-text="$t('number-selected')"
      :checkbox-text="$t('checkbox')"
      :no-data-text="$t('subtext-default')"
      :delete-text="$t('delete')"
      :rows-per-page-text="$t('rows-per-page')"
      :of-text="$t('of')"
      :previous-text="$t('previous-pagination')"
      :next-text="$t('next')"
      :fetching="fetching"
      :headers="tableHeaders"
      :items="recipientsDetails as any"
      :total="recipientsDetails.length"
      :search-placeholder="$t('search')"
      search-by="subject"
      with-search
    >
      <template #[`body.cell.created_at`]="props">
        <div class="tw-inline-flex">
          <span v-format-date="`MMM D, YYYY`">{{ props.tdValue }}</span>
        </div>
      </template>
      <template #[`body.cell.subject`]="props">
        <span
          v-if="props.tdValue.length > 35"
          v-truncate
          v-tippy="{
            content: props.tdValue,
            placement: 'bottom',
          }"
        >
          {{ props.tdValue }}
        </span>
        <span v-else>{{ props.tdValue }}</span>
      </template>
      <template #[`body.cell.recipient`]="props">
        <div class="tw-relative tw-inline-flex" data-clarity-mask="true">
          <span
            v-if="props.tdValue.length > 35"
            v-truncate
            v-tippy="{
              content: props.tdValue,
              placement: 'bottom',
            }"
          >
            {{ props.tdValue }}
          </span>
          <span v-else>{{ props.tdValue }}</span>
        </div>
      </template>
      <template #[`body.cell.sender`]="props">
        <div class="tw-relative tw-inline-flex" data-clarity-mask="true">
          <span
            v-if="props.tdValue.length > 35"
            v-truncate
            v-tippy="{
              content: props.tdValue,
              placement: 'bottom',
            }"
          >
            {{ props.tdValue }}
          </span>
          <span v-else>{{ props.tdValue }}</span>
        </div>
      </template>
    </cl-data-table>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useGlobalOrganisationIDBasedOnRoute } from "@/composables/useGlobalOrganisationIDBasedOnRoute";
import { useIncidents } from "../../useIncidents.store";

const { globalOrganisationId } = useGlobalOrganisationIDBasedOnRoute();

const { t } = useI18n();
const {
  recipientsDetails,
  getRecipientsDetails: fetchRecipientsDetails,
  incidentDetails,
} = useIncidents();

const fetching = ref(true);

const tableHeaders = [
  {
    label: t("subject"),
    key: "subject",
    sortable: true,
  },
  {
    label: t("recipient"),
    key: "recipient",
    sortable: true,
  },
  {
    label: t("sender"),
    key: "sender",
    sortable: true,
  },
  {
    label: t("customer"),
    key: "customer_name",
    sortable: true,
  },
];

const getRecipientsDetails = async () => {
  if (!globalOrganisationId.value) return;
  if (!incidentDetails.value?.internet_message_id) return;

  try {
    fetching.value = true;

    await fetchRecipientsDetails({
      globalOrganisationID: globalOrganisationId.value,
      internetMessageID: incidentDetails.value?.internet_message_id,
    });
  } finally {
    fetching.value = false;
  }
};
getRecipientsDetails();
</script>
